import { memo } from 'react';

import { DropdownMenu } from '@air/primitive-dropdown-menu';
import { useSysadmin } from '@air/sysadmin';

import { WorkspaceHeaderInformationDropdownTrigger } from '~/components/v2/components/workspace/workspace-header/ui2026/WorkspaceHeaderInformationDropdownTrigger';
import { WorkspaceHeaderInformationDropdownDevToolsItems } from '~/components/v2/components/workspace/workspace-header/WorkspaceHeaderInformationDropdownDevToolsItems';
import { WorkspaceHeaderInformationDropdownStorageItems } from '~/components/v2/components/workspace/workspace-header/WorkspaceHeaderInformationDropdownStorageItems';
import { WorkspaceHeaderInformationDropdownSwitchWorkspaceItems } from '~/components/v2/components/workspace/workspace-header/WorkspaceHeaderInformationDropdownSwitchWorkspaceItems';
import { WorkspaceHeaderInformationDropdownThemeItems } from '~/components/v2/components/workspace/workspace-header/WorkspaceHeaderInformationDropdownThemeItems';
import { WorkspaceHeaderInformationDropdownWorkspaceItems } from '~/components/v2/components/workspace/workspace-header/WorkspaceHeaderInformationDropdownWorkspaceItems';
import { useInternalMenu } from '~/components/v2/hooks/useInternalMenu';
import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export const WorkspaceHeaderInformationDropdown = memo(() => {
  const { currentWorkspace } = useCurrentWorkspace();
  const { isInternal } = useSysadmin();
  const { isInternalMenuVisible } = useInternalMenu();

  return (
    <DropdownMenu
      align="start"
      className="w-[280px] min-w-[280px]"
      side="bottom"
      sideOffset={4}
      trigger={
        currentWorkspace ? <WorkspaceHeaderInformationDropdownTrigger currentWorkspace={currentWorkspace} /> : null
      }
    >
      <WorkspaceHeaderInformationDropdownStorageItems />
      <WorkspaceHeaderInformationDropdownWorkspaceItems />
      {!isInternal && <WorkspaceHeaderInformationDropdownSwitchWorkspaceItems />}
      <WorkspaceHeaderInformationDropdownThemeItems />
      {isInternalMenuVisible && <WorkspaceHeaderInformationDropdownDevToolsItems />}
    </DropdownMenu>
  );
});

WorkspaceHeaderInformationDropdown.displayName = 'WorkspaceHeaderInformationDropdown';
